// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__RbPtA","removeIcon":"styles_removeIcon__1HrwN"};